"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { viuGoTrendClass } from "./ViuGoTrendUtils";

export default function ViuGoCorrectScoresSection({ title, correctScoresFull }) {
    const { home = [], draw = [], away = [] } = correctScoresFull || {};
    const allScores = [...home, ...draw, ...away];

    if (allScores.length === 0) return null;

    return (
        <div className="viugo-ods-detail-item ods-100 flex min-w-0 flex-col !bg-transparent !p-0">
            <div className="relative flex w-full flex-row gap-[10px]">
                <div className="kbv-text-black-odds-indigo-slate relative z-[1] cursor-default select-none rounded-t-[4px] bg-[var(--theme-live-chip-bg)] px-2 py-1 text-[12px] font-bold leading-tight">
                    {title}
                </div>
            </div>
            <div className="kbv-bg-odt-item-indigo-slate -mt-px rounded-b-[4px] rounded-tr-[4px] p-2.5">
                <div className="viugo-odstb-odds-list viugo-scores-grid">
                    {home.map((item, i) => (
                        <div key={`h${i}`}>
                            <div className="viugo-title-odds">{item.label}</div>
                            <div className="score-values">
                                <div className={`odds ods-100 ods-white max-md:!text-[9px] ${viuGoTrendClass(item.trend)}`}>
                                    {displayValue(item.value)}
                                </div>
                                {item.value2 !== undefined && (
                                    <div className={`odds ods-100 ods-white max-md:!text-[9px] ${viuGoTrendClass(item.trend2)}`}>
                                        {displayValue(item.value2)}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}

                    {draw.map((item, i) => (
                        <div key={`d${i}`}>
                            <div className="viugo-title-odds">{item.label}</div>
                            <div className="score-values">
                                <div className={`odds ods-100 ods-white max-md:!text-[9px] ${viuGoTrendClass(item.trend)}`}>
                                    {displayValue(item.value)}
                                </div>
                            </div>
                        </div>
                    ))}

                    {away.map((item, i) => (
                        <div key={`a${i}`}>
                            <div className="viugo-title-odds">{item.label}</div>
                            <div className="score-values">
                                <div className={`odds ods-100 ods-white max-md:!text-[9px] ${viuGoTrendClass(item.trend)}`}>
                                    {displayValue(item.value)}
                                </div>
                                {item.value2 !== undefined && (
                                    <div className={`odds ods-100 ods-white max-md:!text-[9px] ${viuGoTrendClass(item.trend2)}`}>
                                        {displayValue(item.value2)}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}

                    <div>
                        <div className="viugo-title-odds">AOS</div>
                        <div className="score-values">
                            <div className="odds ods-100 ods-white max-md:!text-[9px]">-</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
